export const mediaExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "pdf"];

export const BREAKPOINTS = {
    mobile: 0,
    tablet: 640,
    desktop: 1024,
};
